const collectionMap = new Map();
let shopifyQty1 = varintsShopifyStore;
shopifyQty1.split(",").map(res => {
	let sp = res.split("/");
	collectionMap.set(sp[0], sp[1]);
});
let countryCodeTemp = "";
if (typeof countryCode !== 'undefined') {
    countryCodeTemp = countryCode;
}
fetch('https://ipapi.co/country/')
  .then(response => response.text())
  .then(code => {
    countryCodeTemp = code;
    // Re-initialize geolocation with the country code
    initializeWebbeeGeolocation();
  })
  .catch(() => {
    countryCodeTemp = "";
  });
function webbeeGeolocation19(variantSku, domainName) {
	console.log("webbeeGeolocation19 called with variantSku: " + variantSku + ", domainName: " + domainName + ", countryCode: " + countryCodeTemp);
	let encodedValues = encodeURIComponent(JSON.stringify({ "variantSKUList": variantSku, "domainName": domainName ,"countryCode": countryCodeTemp}));
	$.ajax({
		type: 'GET', url: 'https://hooks.webbeeglobal.com/ShopifyAmazonFBAConnecotr/shopify/location-qty', async: false,
		dataType: 'jsonp', jsonp: 'callback', jsonpCallback: 'callback', data: encodedValues,
		success: function(callback) {
			console.log("webbeeGeolocation19 https://hooks.webbeeglobal.com/ShopifyAmazonFBAConnecotr/shopify/location-qty status: " 
				+ callback['status'] + " geoLocationZeroInventory : " 
				+ callback['geoLocationZeroInventory']);
			if (callback['status'] == 'success' && callback['data'].length > 0) {
				responseFromServer = callback['data'];
				console.log("webbeeGeolocation19 https://hooks.webbeeglobal.com/ShopifyAmazonFBAConnecotr/shopify/location-qty :" + responseFromServer);
				for (let i = 0; i < responseFromServer.length; i++) {
					let object = responseFromServer[i];
					idquantity.set(object['variantSKU'], object['quantity']);
				}
				try{
				if(page==="listpage"){
					soldOutGeoLocation();
				}
				}catch(exception){
				}
					let qty = idquantity.get(webbeeSku);
					if(qty===0 || qty===null || qty===undefined){
						$(btn).attr("disabled",true);
						try{
						if(txt){
						$(btn).html(txt);
						}
						}catch(Exception){}
					}else{
						$(btn).attr("disabled", false);
					}
			}else if(callback['status'] == 'fail' && callback['geoLocationZeroInventory'] == 'Yes'){
				idquantity.set('zero inventory', true); 
			}else{
					let qty = idquantity.get(webbeeSku);
					if(qty===0 || qty===null || qty===undefined){
						$(btn).attr("disabled",true);
						try{
						if(txt){
						$(btn).html(txt);
						}
						}catch(Exception){}
					}else{
						$(btn).attr("disabled", false);
					}
                }
			// Notify that geolocation data is ready
			if (typeof markGeolocationDataLoaded === 'function') {
				markGeolocationDataLoaded();
			}
		},
		error: function(jqXHR, textStatus, errorThrown) {
			$(btn).attr("disabled", false);
			// Even on error, mark as loaded so page doesn't hang
			if (typeof markGeolocationDataLoaded === 'function') {
				markGeolocationDataLoaded();
			}
		}
	});
}
function initializeWebbeeGeolocation() {
	console.log("vavvvvvvvvvvvvvvv test ==================" + variantSku);
    webbeeGeolocation19(variantSku, domainName);

	$(btn).on('click', function(evt) {
	let skus = $("#webbeesku").val();
	skus = webbeeSku;
	let qty = idquantity.get(skus);	
	let cartqty = collectionMap.get(skus);
	if (cartqty === undefined) {
		cartqty = 0;
	}
	if (Number(cartqty) + 1 > Number(qty)) {
		$(btn).attr("disabled", "true");
		evt.preventDefault();
		$("#msg").html("Available quantity " + Number(qty));
	} else {
		$("#msg").html("");
	}
	if (qty === undefined || qty === 0) {
		$(btn).attr("disabled", "true");
		$("#msg").html("Available quantity 0");
		evt.preventDefault();
	}
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initializeWebbeeGeolocation);
} else {
	initializeWebbeeGeolocation();
}